import axios from 'axios'
import * as Config from '../config'

export const REPORTS_REQUEST = "REPORTS_REQUEST"
export const REPORTS_SUCCESS = "REPORTS_SUCCESS"
export const REPORTS_ERROR = "REPORTS_ERROR"

export function Get(){
    return (dispatch)=>{
        dispatch({
            type:REPORTS_REQUEST
        });

        axios.get(
            Config.apiUrl + "/report/list"
        )
        .then((response)=>{
            dispatch({
                type:REPORTS_SUCCESS,
                payload:response.data
            })
        })
        .catch((err)=>{
            dispatch({
                type:REPORTS_ERROR
            })
        })
    }
}




// WEBPACK FOOTER //
// ./src/actions/reportsActions.js